<style lang="less" scoped>
    .item-preview{
        width: 300px;
        box-sizing: content-box;
        border: 1px solid #dddee1;
        box-shadow: 0 1px 3px 0 rgba(55,55,55,.2);
        margin: 0 auto;
    }
    .list-page{
        position: relative;
        max-width: 400px;
        height: 140px;
        border: 1px solid #dddee1;
        box-shadow: 0 1px 3px 0 rgba(55,55,55,.2);
        box-sizing: content-box;
        margin: 0 auto;
    }
    .image-small{
        position: absolute;
        top: 0;
        left: 0;
        display: inline-block;
        width: 140px;
        height: 140px;
        vertical-align: top;
        img{
            width: 100%;
            height: 100%;
            vertical-align: middle;
        }
    }
    .list-text-container{
        display: inline-block;
        height: 140px;
        width: 100%;
        padding-left: 150px;
    }
    .list-text{
        display: flex;
        align-items:center;
        height: 100%;
        .list-title{
            font-size: 16px;
            color: #4a4a4a;
            height: 22px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
        .list-desc{
            max-height: 43px;
            font-size: 14px;
            color: #9b9b9b;
            margin-top: 10px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            white-space: normal;
        }
        .list-price{
            height: 22px;
            margin-top: 10px;
        }
    }
    .carousel{
        width: 300px;
    }
    .image-wrapper{
        img{
            max-width: 100%;
            vertical-align: middle;
        }
    }
    .price-color{
        color: #ff6466;
    }
    .detail-title{
        line-height: 32px;
        font-size: 19px;
        color: #666;
        padding: 10px 10px 5px 10px;
        white-space: normal;
    }
    .detail-price{
        font-size: 21px;
        padding: 0 10px;
    }
    .detail-description-title{
        text-decoration: none;
        text-align: center;
        height: 60px;
        line-height: 60px;
        font-size: 18px;
        color: #666666;
    }
    .detail-description{
        white-space: normal;
        /deep/ img {
            max-width: 100%;
            vertical-align: middle;
        }
    }
    .detail-sub-items {
        padding: 0 10px;
        margin-bottom: 10px;
        .cur-sub-item{
            position: relative;
            height: 80px;
            margin-bottom: 10px;
            .sub-item-text-container{
                display: inline-block;
                height: 80px;
                padding-left: 90px;
            }
            .sub-item-image{
                position: absolute;
                top: 0;
                left: 0;
                display: inline-block;
                width: 80px;
                height: 80px;
                vertical-align: top;
                img {
                    width: 100%;
                    height: 100%;
                    vertical-align: middle;
                }
            }
            .sub-item-text{
                display: flex;
                align-items:center;
                height: 100%;
            }
        }
        .detail-sub-item{
            line-height: 22px;
            padding: 0 3px;
            margin-right: 6px;
            margin-top: 6px;
            display: inline-block;
            text-align: center;
            overflow: hidden;
            vertical-align: middle;
            color: #4a4a4a;
            border: solid 1px #9b9b9b;
            border-radius: 2px;
            font-size: 12px;
            cursor: pointer;
            &:hover {
                background: #f5f5f5;
            }
        }
        .detail-sub-item-cur{
            border-color: #ff6466;
            color: #ff6466;
        }
    }

</style>
<template>
    <div>
        <Divider>列表页</Divider>
        <div class="list-page">
            <div class="image-small">
                <img :src="$util.mallFileUrl(item.image_small)" alt="" v-if="item.image_small">
            </div>
            <div class="list-text-container">
                <div class="list-text">
                    <div style="width: 100%;">
                        <div class="list-title">{{item.formal_title || '暂无标题...'}}</div>
                        <div class="list-desc color-grey">{{item.desc || '暂无简介...'}}</div>
                        <div class="list-price price-color">{{item_min_price}}</div>
                    </div>
                </div>
            </div>
        </div>
        <Divider>购买页</Divider>
        <div class="item-preview">
            <Carousel class="carousel" loop>
                <CarouselItem v-for="image_url in image_normal_urls" :key="image_url">
                    <div class="image-wrapper">
                        <img :src="image_url" alt="">
                    </div>
                </CarouselItem>
            </Carousel>
            <div class="header">
                <div class="detail-title">{{item.title || '暂无标题...'}}</div>
                <div class="detail-price price-color">{{item_price}}</div>
                <div class="hr"></div>
                <div class="detail-sub-items">
                    <div class="cur-sub-item">
                        <div class="sub-item-image" v-if="(cur_sub_item && cur_sub_item.url_image) || item.image_small">
                            <img :src="$util.mallFileUrl(cur_sub_item.url_image)" alt="" v-if="cur_sub_item.url_image">
                            <img :src="$util.mallFileUrl(item.image_small)" alt="" v-else>
                        </div>
                        <div class="sub-item-image" v-else style="background: #f5f5f5">
                            <Icon type="ios-image-outline" size="80" color="#dddee1" />
                        </div>
                        <div class="sub-item-text-container">
                            <div class="sub-item-text">
                                <div>
                                    <div class="list-price price-color">{{sub_item_price}}</div>
                                    <div class="list-title">库存 xxx 件</div>
                                    <div class="list-desc color-grey">已选 {{cur_sub_item.title || `子项${cur_sub_index+1}`}} x1</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>规格</div>
                    <div class="detail-sub-item"
                         :class="{'detail-sub-item-cur': index === cur_sub_index}"
                         @click="cur_sub_index = index"
                         v-for="(sub_item, index) in item.mall_sub_items"
                         :key="index">
                        {{sub_item.title || `暂无名称(子项${index+1})`}}
                    </div>
                </div>
                <div class="gap" style="background-color:#f6f6f6;height:20px"></div>
                <div class="detail-description-title">产品详情</div>
                <div class="detail-description" v-html="item.description"></div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            item: {
                type: Object,
                required: true
            }
        },
        data(){
            return {
                cur_sub_index: 0,
            }
        },
        computed: {
            image_normal_urls() {
                return this.item.image_normal.split(';').map((path) => {
                    return this.$util.mallFileUrl(path);
                });
            },
            item_price() {
                const len = this.item.mall_sub_items.length;
                if (len === 0){
                    return '¥ 0.00';
                } else if (len === 1) {
                    const sub_item = this.item.mall_sub_items[0];
                    const price = parseFloat(sub_item.price || 0);
                    return isNaN(price) ? '¥ 0.00' : `¥ ${this.$util.formatPrice(price)}`;
                } else {
                    const prices =this.item.mall_sub_items.map((sub_item) => {
                        const price = parseFloat(sub_item.price || 0);
                        return isNaN(price) ? 0 : price;
                    });
                    const max = Math.max(...prices);
                    const min = Math.min(...prices);
                    console.log(prices, max, min);
                    if (max === min) {
                        return `¥ ${this.$util.formatPrice(min)}`;
                    } else {
                        return `¥ ${this.$util.formatPrice(min)} - ${this.$util.formatPrice(max)}`;
                    }
                }
            },
            item_min_price() {
                const len = this.item.mall_sub_items.length;
                if (len === 0){
                    return '¥ 0.00';
                } else if (len === 1) {
                    const sub_item = this.item.mall_sub_items[0];
                    const price = parseFloat(sub_item.price || 0);
                    return isNaN(price) ? '¥ 0.00' : `¥ ${this.$util.formatPrice(price)}`;
                } else {
                    const prices =this.item.mall_sub_items.map((sub_item) => {
                        const price = parseFloat(sub_item.price || 0);
                        return isNaN(price) ? 0 : price;
                    });
                    const min = Math.min(...prices);
                    return `¥ ${this.$util.formatPrice(min)}`;
                }
            },
            cur_sub_item() {
                const len = this.item.mall_sub_items.length;
                if (this.cur_sub_index >= len) {
                    this.cur_sub_index = 0;
                }
                return this.item.mall_sub_items[this.cur_sub_index];
            },
            sub_item_price() {
                if (!this.cur_sub_item) return '¥ 0.00';
                const price = parseFloat(this.cur_sub_item.price || 0);
                return isNaN(price) ? '¥ 0.00' : `¥ ${this.$util.formatPrice(price)}`;
            }
        },
        created(){
            //
        },
        mounted(){
            //
        },
        methods: {
            test(){
                Util.ajax.get('api_url', {
                    params: {
                        //
                    }
                }).then((response)=>{
                    return response.data;
                }).then((res)=>{
                    console.log(res);
                    if(res.code === 1){
                        //成功
                    }else{
                        //失败
                        this.$Modal.warning({title: '错误', content: res.msg});
                    }
                }).catch((e)=>{
                    console.log(e);
                    this.$Modal.warning({title: '错误', content: e.message});
                }).finally(()=>{
                    // always executed
                });
            }
        }
    }
</script>
